// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Aufgabe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useRemoveToolFromAufgabe(): (
  aufgabeId: string,
  toolId: string
) => Promise<Aufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, toolId) =>
      (await getAPI()).aufgaben.removeToolFromAufgabe({ aufgabeId, toolId }),
    [getAPI]
  );
}
